import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { IoArrowBackCircleSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import franchiseAdminAPI from "../../../api/franchiseAdminAPI";

const AddFranchise = () => {
  const navigate = useNavigate();
  const email = Cookies.get("userEmail");
  const [data, setData] = useState({
    id: "",
    organization: "",
    location: "",
  });
  const [formData, setFormData] = useState({
    manageBy: "",
    franchise: "",
    location: "",
  });

  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (email) {
      franchiseAdminAPI
        .getFranchiseDetailsByEmail(email)
        .then((res) => {
          setData({
            id: res.data.id, // ✅ store parentId
            organization: res.data.organization,
            location: res.data.location,
          });
        })
        .catch((err) => {
          console.error("Error fetching franchise details:", err);
        });
    }
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      email: formData.manageBy,
      organization: formData.franchise,
      location: formData.location,
      createdBy: email,
      parentId: data.id,
    };

    try {
      setSaving(true); // ✅ start spinner

      const res = await franchiseAdminAPI.saveFranchises(payload);

      // ✅ wait for alert to complete
      await Swal.fire({
        icon: "success",
        title: "Success",
        text: "Franchise added successfully!",
        timer: 2000,
        showConfirmButton: false,
      });

      navigate("/franchise-dashboard/franchises"); // ✅ navigate back to list
      // reset form
      setFormData({
        manageBy: "",
        franchise: "",
        location: "",
      });
    } catch (err) {
      console.error("Error saving franchise:", err.response || err.message);

      // ❌ error popup
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          err.response?.data?.message ||
          "Failed to add franchise. Please try again.",
      });
    } finally {
      setSaving(false); // ✅ stop spinner
    }
  };

  return (
    <div className="scrollable-container">
      <div className="d-flex justify-content-between mb-3">
        <h3>Add Franchise</h3>
        <Button onClick={() => navigate(-1)} variant="info">
          <IoArrowBackCircleSharp /> Back
        </Button>
      </div>

      <div className="card p-4">
        <Form onSubmit={handleSubmit}>
          {/* Manage By */}
          <Form.Group className="mb-3">
            <Form.Label>Manage By (Email)</Form.Label>
            <Form.Control
              type="email"
              name="manageBy"
              value={formData.manageBy}
              onChange={handleChange}
              placeholder="Enter email"
              required
            />
          </Form.Group>

          {/* Franchise */}
          <Form.Group className="mb-3">
            <Form.Label>Franchise</Form.Label>
            <Form.Control
              type="text"
              name="franchise"
              value={formData.franchise}
              onChange={handleChange}
              placeholder="Enter organization name"
              required
            />
          </Form.Group>

          {/* Location */}
          <Form.Group className="mb-3">
            <Form.Label>Location</Form.Label>
            <Form.Control
              type="text"
              name="location"
              value={formData.location}
              onChange={handleChange}
              placeholder="Enter location"
              required
            />
          </Form.Group>

          <Button type="submit" variant="primary" disabled={saving}>
            {saving ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                ></span>
                Saving...
              </>
            ) : (
              "Save Franchise"
            )}
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default AddFranchise;
